import React, { FC, PropsWithChildren } from 'react';

import { BlockTimer } from '../Timer';

import styles from './DiscountBlockWithTimer.module.scss';

export const DiscountBlockWithTimerWrapper = ({ children }: PropsWithChildren) => (
    <div className={styles.discountBlockWithTimerWrapper}>
        {children}
    </div>
);

export interface IDiscountBlockWrapperProps {
    title: string;
    discountValue: string;
    discountCoupon: string;
}

export const DiscountBlockWrapper: FC<IDiscountBlockWrapperProps> = ({
                                                                         title,
                                                                         discountValue,
                                                                         discountCoupon
                                                                     }) => (
    <div>
        <span className={styles.discountBlockWithTimerTitle}>
            {title}
        </span>
        <div className={styles.discountWrapper}>
            <div className={styles.discountPointer}>
                <span className={styles.discountValue}>
                    {discountValue}
                </span>
            </div>
            <span className={styles.discountCoupon}>
                {discountCoupon}
            </span>
        </div>
    </div>
);

export interface ITimerWrapperProps {
    discountTimerTitle: string;
    timerMinutes: number;
    timerSeconds: number;
    setMinutes: (minutes: number) => void;
    setSeconds: (seconds: number) => void;
    endOfTimerHandler: () => void;
    minutesTitle?: string;
    secondsTitle?: string;
}

export const TimerWrapper: FC<ITimerWrapperProps> = ({
                                                         discountTimerTitle,
                                                         timerMinutes,
                                                         timerSeconds,
                                                         setMinutes,
                                                         setSeconds,
                                                         endOfTimerHandler,
                                                         minutesTitle,
                                                         secondsTitle
                                                     }) => (
    <div>
        <span>
            {discountTimerTitle}
        </span>
        <BlockTimer
            minutes={timerMinutes}
            seconds={timerSeconds}
            setMinutes={setMinutes}
            setSeconds={setSeconds}
            endOfTimerHandler={endOfTimerHandler}
            minutesTitle={minutesTitle}
            secondsTitle={secondsTitle}
        />
    </div>
);

export interface IDiscountBlockWithTimerProps extends IDiscountBlockWrapperProps, ITimerWrapperProps {}

export const DiscountBlockWithTimer: FC<IDiscountBlockWithTimerProps> = (props: IDiscountBlockWithTimerProps): React.JSX.Element => {

    return (
        <DiscountBlockWithTimerWrapper>
            <DiscountBlockWrapper {...props} />
            <TimerWrapper {...props} />
        </DiscountBlockWithTimerWrapper>
    );
};
